<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Countries</h2>
      </div>
    </div>

    <!-- Filters -->
    <div class="wrapper wrapper-content">
      <div class="ibox-content mb-1 px-3 py-2">
        <div class="form-group mb-1">
          <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
            <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">Country</label>
              <input type="text" class="form-control my-md-2 my-lg-0" v-model="searchField.country" />
            </div>
            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Status</label>
               <select class="form-select" name="reason to resolve" id="resolveReason" v-model="searchField.status">
                <option value="" >All</option>
                <option v-for="status in CountryStatus" :key="status.status" :value="status.status">{{ status.status }}</option>
              </select>
            </div>
            <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="search()">
              Search
            </span>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">Country List</h5>
          <div class="d-flex">

            <div class="position-relative align-self-center" v-if="roleprivileges.includes('Countries Add Countries')" :class="{ 'mr-3': countryList.length != 0 }"
              aria-label="Create Country" tabindex="0">
              <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17" alt="Create country"
                @click="CreateCountry(0)" />
              <div class="tool-tip">{{ $t("navigations.create country") }}</div>
            </div>
            <!-- <div
            class="position-relative cursor-pointer"
            v-if="countryList.length != 0"
            @click.prevent="showFilter = !showFilter"
          >
            <img
              src="../../assets/img/filter.png"
              width="17"
              height="17"
              alt="filter table"
            />
            <div class="tool-tip">{{ $t("navigations.filter") }}</div>
          </div> -->
          </div>
        </div>
        <div class="ibox-content">
          <!-- <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
          <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
            <div
              class=" table-multi-select-dropdown"
              @click.stop="dropdownOpen = !dropdownOpen"
            >
              <div class="selected-options">
                <span>{{ $t("navigations.select columns") }}</span>
              </div>
              <div class="dropdown-arrow"></div>
            </div>
            <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
              <label v-for="(column, index) in getColumns" :key="index">
                <input
                  type="checkbox"
                  v-model="selectedcolumnobj[column]"
                  :value="true"
                />
                {{ column }}
              </label>
            </div>
          </div>
        </div> -->
          <div class="text-center" v-if="showTableLoading === true">
            <img src="../../assets/img/loading.gif" width="15" class="" alt="Waiting for login" />
            <div>
              {{ $t("navigations.please wait while the list is being loaded") }}
            </div>
          </div>

          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th class="sort_block"  @click="SortSelected('countryName', 1)"><div class="d-flex flex-row justify-content-between">
                     Country Name
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div></th>
                  <th class="sort_block"  @click="SortSelected('countryCode', 1)"><div class="d-flex flex-row justify-content-between">
                    Country Code
                     <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>Region</th>
                  <th class="sort_block" @click="SortSelected('status', 1)"><div class="d-flex flex-row justify-content-between">
                    Status
                     <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                      </div>
                  </th>
                  <th class="sort_block" @click="SortSelected('statusDate', 1)"><div class="d-flex flex-row justify-content-between">
                    Status Date
                     <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>
                  <th>Contact Person</th>
                  <th>Regulatory Authority</th>
                  <th>Notes</th>
                  <th class="text-center">Active</th>
                  <th>Language</th>
                  <!-- <th >Language Code</th> -->
                  <th class="text-center">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in countryList" :key="item.id">
                  <td>{{ item.countryName }}</td>
                  <td>{{ item.countryCode }}</td>
                  <td>{{ item.region }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{  formatDateDDMMYYYY(item.statusDate) }}</td>
                  <td>{{ item.contactPerson }}</td>
                  <td>{{ item.regulatoryAuthority }}</td>
                  <td>{{ item.notes }}</td>
                  <td class="text-center">
                    <input type="checkbox" :checked="item.active" onclick="return false" readonly />
                  </td>
                  <!-- Join all language names -->
                  <td>
                    {{item.languages ? item.languages.map(l => l.language).join(", ") : ""}}
                  </td>
                  <!-- <td>{{ item.languageCode }}</td> -->
                  <td class="text-center">
                    <i class="fa fa-edit edit-delete" @click="EditCountry(item.id)" style="color: #a13b7c"></i>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-trash edit-delete" style="color: #a13b7c" @click="DeleteCountry(item.id)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div v-if="countryList.length != 0" class="row mt-1 mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div class="
                  dataTables_paginate
                  paging_simple_numbers
                  pagination
                  float-right
                ">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#618bd7"
                    @update:modelValue="loadPage" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./StudyCountry.js"></script>